export default __webpack_public_path__ + "static/media/pictogramBeaconUnlock64.14363c30.svg";